<template>
  <div>
    <div
      v-if="requestedStaffs.length" 
      class="table-responsive"
    >
      <table class="table table-bordered table-striped table-vcenter">
        <thead class="table-dark">
          <tr>
            <th>Staff Name</th>
            <th>Project Credits</th>
            <th>Headhunting Credits</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="staff in requestedStaffs"
            :key="staff.id"
          >
            <td>
              <a
                v-if="showUrl"
                :href="getStaffCreditUrl(staff.id)"
              >{{ staff.user.full_name }}</a>
              <span v-else>{{ staff.user.full_name }}</span>
            </td>
            <td>{{ formatCredits(staff.total_month_credits_normal) }}</td>
            <td>{{ formatCredits(staff.total_month_credits_head_hunting) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-else
      class="alert alert-info"
    >
      <small>No data</small>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "RequestedStaffTable",
  props: {
    requestedStaffs: {
      type: Array,
      default: () => [],
    },
    loadingRequests: {
      type: Boolean,
      default: false,
    },
    dateRange: {
      type: Object,
      default: () => ({
        start: moment().startOf("month").format("YYYY-MM-DD"),
        end: moment().endOf("month").format("YYYY-MM-DD"),
      }),
    },
    showUrl:{
      type: Boolean,
      default: true,
    }
  },
  methods: {
    formatCredits(value) {
      return Math.round(Number(value || 0) * 100) / 100;
    },
    getStaffCreditUrl(staffId) {
      const url = `admin/credit-tracking/staff/${staffId}`;
      const staffUrl = new URL(url, window.location.origin);
      staffUrl.searchParams.append("start_date", moment(this.dateRange.start).format("YYYY-MM-DD"));
      staffUrl.searchParams.append("end_date", moment(this.dateRange.end).format("YYYY-MM-DD"));

      return staffUrl;
    },
  },
};
</script>

<style scoped></style>
